"use strict";
/**
 * AngularJS toast module.
 *
 * @packageDocumentation
 * @module Toast
 */
Object.defineProperty(exports, "__esModule", { value: true });
//#region Util Imports
var lodash_es_1 = require("lodash-es");
exports.SERVICE_NAME = 'imr.controls.services.toast';
exports.PROVIDER_NAME = 'imr.controls.services.provider.toast';
var ToastType;
(function (ToastType) {
    ToastType[ToastType["Success"] = 1] = "Success";
    ToastType[ToastType["Info"] = 2] = "Info";
    ToastType[ToastType["Warning"] = 3] = "Warning";
    ToastType[ToastType["Error"] = 4] = "Error";
})(ToastType || (ToastType = {}));
/**
 * A service for displaying toast messages.
 *
 * @category Service
 */
var IMRToastService = /** @class */ (function () {
    //#region Ctor
    function IMRToastService(toastrService) {
        this.toastrService = toastrService;
    }
    IMRToastService.prototype.success = function (messageTitle, messageOptions, options) {
        return this.show(ToastType.Success, messageTitle, messageOptions, options);
    };
    IMRToastService.prototype.info = function (messageTitle, messageOptions, options) {
        return this.show(ToastType.Info, messageTitle, messageOptions, options);
    };
    IMRToastService.prototype.warning = function (messageTitle, messageOptions, options) {
        return this.show(ToastType.Warning, messageTitle, messageOptions, options);
    };
    IMRToastService.prototype.error = function (messageTitle, messageOptions, options) {
        return this.show(ToastType.Error, messageTitle, messageOptions, options);
    };
    /**
     * Removes all toasts.
     */
    IMRToastService.prototype.clear = function () {
        this.toastrService.clear();
    };
    //#endregion
    //#region Private
    IMRToastService.prototype.show = function (type, title, messageOptions, options) {
        var _this = this;
        if (messageOptions === void 0) { messageOptions = null; }
        if (options === void 0) { options = null; }
        var actualTitle = title;
        var actualMessage = lodash_es_1.isString(messageOptions)
            ? messageOptions
            : null;
        var actualOptions = !lodash_es_1.isString(messageOptions)
            ? messageOptions
            : options;
        var timeout = actualOptions != null ? actualOptions.displayTime || 0 : 0;
        var toastrOptions = {
            allowHtml: true,
            closeButton: true,
            extendedTimeOut: timeout,
            tapToDismiss: false,
            timeOut: timeout,
            toastClass: 'toast imr-toast-service-toastr',
            onHidden: function (closedByButton) {
                if (actualOptions != null && actualOptions.onHidden != null) {
                    actualOptions.onHidden({
                        closedByButton: closedByButton,
                    });
                }
            },
        };
        if (actualMessage == null) {
            toastrOptions.toastClass =
                toastrOptions.toastClass +
                    ' imr-toast-service-toastr_no-message';
        }
        var toastr;
        switch (type) {
            case ToastType.Error:
                toastr = this.toastrService.error(actualMessage, actualTitle, toastrOptions);
                break;
            case ToastType.Info:
                toastr = this.toastrService.info(actualMessage, actualTitle, toastrOptions);
                break;
            case ToastType.Warning:
                toastr = this.toastrService.warning(actualMessage, actualTitle, toastrOptions);
                break;
            default:
            case ToastType.Success:
                toastr = this.toastrService.success(actualMessage, actualTitle, toastrOptions);
                break;
        }
        return {
            close: function () {
                _this.toastrService.clear(toastr);
            },
        };
    };
    return IMRToastService;
}());
exports.IMRToastService = IMRToastService;
/**
 * A provider for {@link IMRToastService}
 *
 * @category Provider
 */
var IMRToastServiceProvider = /** @class */ (function () {
    function IMRToastServiceProvider() {
        //#region IServiceProvider Implementation
        this.$get = [
            'toastr',
            function (toastr) {
                return new IMRToastService(toastr);
            },
        ];
        //#endregion
    }
    return IMRToastServiceProvider;
}());
exports.IMRToastServiceProvider = IMRToastServiceProvider;
//# sourceMappingURL=toast.service.js.map